
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","viewBox":"0 0 8 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.78022 6.46633L0.153411 11.19C-0.0528792 11.4005 -0.0507749 11.7373 0.157621 11.9478L0.984889 12.775C1.19749 12.9855 1.53851 12.9855 1.74901 12.7729L7.63671 6.84733C7.74196 6.74208 7.79459 6.60526 7.79459 6.46633C7.79459 6.3274 7.74196 6.19057 7.63671 6.08532L1.74901 0.159728C1.53851 -0.0528789 1.1975 -0.052879 0.98489 0.157622L0.157622 0.984889C-0.050774 1.19539 -0.0528783 1.53219 0.153412 1.74269L4.78022 6.46633Z","fill":"#444444"}})])
          )
        }
      }
    